import { UIFlyAnywhere } from "@flights/types";

export type State = UIFlyAnywhere | null;

export const getInitialState = (): State => ({
  fetchStatus: "initial"
});
